  const processingRoutes = {
    processings: "/processings",
    processingDetails: "/processings/details/:contract_id",
    processingNewForms: "/processings/forms/:contract_id",
    processingDocuments: "/processings/documents/:contract_id",
  };

  export default processingRoutes;
